import { render, staticRenderFns } from "./ResidentSignUpWithPassword.vue?vue&type=template&id=3de59407&scoped=true&"
import script from "./ResidentSignUpWithPassword.vue?vue&type=script&lang=ts&"
export * from "./ResidentSignUpWithPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentSignUpWithPassword.vue?vue&type=style&index=0&id=3de59407&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de59407",
  null
  
)

export default component.exports